import EzModalController from 'layouts/modal/modal-controller';
import { parseBoolean, removeParamFromUrl } from 'lib/helpers';
import EzUser from 'init/init-user';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import { buildPlanItems } from 'lib/plan-helpers';
import {
  REBUY_POPUP_CLICK,
  REBUY_UPGRADE_CLICK,
  EC_VIEW_PLANS,
  EC_PLAN_SELECTION,
} from 'components/analytics/conversions/constants/actions';

export default class RebuyCreditsModalController extends EzModalController {
  declare readonly element: HTMLElement;

  declare submitBtnTarget: HTMLButtonElement;

  declare selectedPlanTarget: HTMLInputElement;

  declare planOptionTargets:HTMLElement[]

  declare upgradeFromCreditPlanTarget:HTMLInputElement

  declare isSelectedClass:string;

  static targets = [
    'submitBtn',
    'selectedPlan',
    'planOption',
    'upgradeFromCreditPlan',
  ];

  static classes = [
    'isSelected',
  ];

  currentPlanEvent = REBUY_POPUP_CLICK;

  connect() {
    super.connect();

    this.trackPlanOptions();

    if (EzUser.signedIn) removeParamFromUrl('rebuy_credits');
  }

  selectPlan(event) {
    const { target } = event;
    const { upgradeFromCreditPlan } = target.dataset;

    if (!this.isValidPlanOptionTarget(target) || this.planOptionAlreadySelected(target)) return;

    this.processHiddenVariables(parseBoolean(upgradeFromCreditPlan));

    this.currentPlanOption().classList.remove(this.isSelectedClass);
    target.classList.add(this.isSelectedClass);

    this.updatePlanSelection(target.dataset);
  }

  trackPlanSelection() {
    // track the type of click
    sendTrackingEvent({
      element: this.element,
      data: { action: this.currentPlanEvent },
    });

    // track add to cart
    const planData = this.parseRenderedPlan(this.currentPlanOption());
    const builtPlans = buildPlanItems({ plans: [planData] });

    sendTrackingEvent({
      element: this.element,
      data: {
        action: EC_PLAN_SELECTION,
        items: builtPlans,
      },
    });
  }

  /* Private methods below */
  isValidPlanOptionTarget(target:HTMLElement) {
    return this.planOptionTargets.includes(target);
  }

  planOptionAlreadySelected(element:HTMLElement) {
    return element.classList.contains(this.isSelectedClass);
  }

  processHiddenVariables(upgradeFromCreditPlan:string) {
    this.currentPlanEvent = upgradeFromCreditPlan ? REBUY_UPGRADE_CLICK : REBUY_POPUP_CLICK;
    this.upgradeFromCreditPlanTarget.value = upgradeFromCreditPlan;
  }

  currentPlanOption() {
    return this.planOptionTargets.find((element) => element.classList.contains(this.isSelectedClass));
  }

  updatePlanSelection({ plan, btnText }) {
    this.submitBtnTarget.value = btnText;
    this.selectedPlanTarget.value = plan;
  }

  trackPlanOptions() {
    const plansData = this.gatherRenderedPlans();

    const items = buildPlanItems({ plans: plansData });

    sendTrackingEvent({
      element: this.element,
      data: {
        action: EC_VIEW_PLANS,
        items,
        non_interaction: true,
      },
    });
  }

  gatherRenderedPlans() {
    const renderedPlans = [];

    this.planOptionTargets.forEach((target) => {
      const parsedPlanData = this.parseRenderedPlan(target);
      renderedPlans.push(parsedPlanData);
    });

    return renderedPlans;
  }

  parseRenderedPlan(target:HTMLElement) {
    const parsedPlanData = JSON.parse(target.dataset.renderedPlan);
    parsedPlanData.plan_id = target.dataset.planId;

    return parsedPlanData;
  }
}
